var _excluded = ["children", "width", "height"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { Primitive as e } from "@radix-ui/react-primitive";
import * as r from "react";
import t from "@babel/runtime/helpers/esm/extends";
export var Arrow = /*#__PURE__*/r.forwardRef(function (o, i) {
  var n = o.children,
      _o$width = o.width,
      s = _o$width === void 0 ? 10 : _o$width,
      _o$height = o.height,
      m = _o$height === void 0 ? 5 : _o$height,
      p = _objectWithoutProperties(o, _excluded);
  /*#__PURE__*/


  return /*#__PURE__*/r.createElement(e.svg, t({}, p, {
    ref: i,
    width: s,
    height: m,
    viewBox: "0 0 30 10",
    preserveAspectRatio: "none"
  }), o.asChild ? n : /*#__PURE__*/r.createElement("polygon", {
    points: "0,0 30,0 15,10"
  }));
});
/*#__PURE__*/

export var Root = Arrow;